var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDoc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 36 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.898 0C6.505 0 5.365 1.125 5.365 2.5v35c0 1.375 1.14 2.5 2.533 2.5h25.333c1.394 0 2.534-1.125 2.534-2.5V10L25.63 0H7.898z",
    fill: "#E2E5E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.718 10.667h8.047L25.035 0v8c0 1.467 1.207 2.667 2.683 2.667z",
    fill: "#B0B7BD"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M35.765 16.889l-7.153-7.111h7.153z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4 32.519c0 .692-.57 1.259-1.267 1.259H1.267A1.267 1.267 0 010 32.518V19.927c0-.693.57-1.26 1.267-1.26h27.866c.697 0 1.267.567 1.267 1.26v12.593z",
    fill: "#27A2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.148 34.222H5.365v1.334h23.783c.689 0 1.252-.6 1.252-1.334V32.89c0 .733-.563 1.333-1.252 1.333z",
    fill: "#CAD1D8"
  })), /*#__PURE__*/React.createElement("text", {
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 10,
    letterSpacing: -0.154,
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 6.685,
    y: 30
  }, "Doc")))));
}

export default SvgDoc;